import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  newAppointmentCategories,
  editAppointmentCategories,
  showAppointmentCategories,
} from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { AppointmentCategoriesProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function AppointmentCategories() {
  return (
    <AppointmentCategoriesProvider>
      <Switch>
        <Route
          exact
          path={newAppointmentCategories.spec}
          render={(props) => (
            <>
              <Can I="new" a="AppointmentCategories">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="AppointmentCategories">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editAppointmentCategories.spec}
          render={(props) => (
            <>
              <Can I="edit" a="AppointmentCategories">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="AppointmentCategories">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showAppointmentCategories.spec}
          render={(props) => (
            <>
              <Can I="show" a="AppointmentCategories">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="AppointmentCategories">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="AppointmentCategories">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="AppointmentCategories">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </AppointmentCategoriesProvider>
  );
}
export default AppointmentCategories;
